import { useCallback, useEffect, useState } from "react";
import PlotAPI from "../plotAPI";
import TeamInfo from "../teamInfo";

interface useVendorsProps {
    projects: any[];
    projectInfo: (projectId: string | number) => any | null;
}

const useVendors = ({ projects, projectInfo }: useVendorsProps) => {
    const [vendorsByProject, setvendorsByProject] = useState<{ unique_token: string; vendorTeams: TeamInfo[] }[]>([]);

    const refreshVendorsByProject = useCallback(() => {
        Promise.all(
            projects.map((project) =>
                PlotAPI.getvendorsForProject(project.unique_token, project.claimed_by_team_subdomain || "public").then(
                    (response) => {
                        return {
                            unique_token: project.unique_token,
                            vendorTeams: response,
                        };
                    }
                )
            )
        ).then((vendors) => {
            setvendorsByProject(vendors);
        });
    }, [projects]);

    useEffect(() => {
        refreshVendorsByProject();
    }, [refreshVendorsByProject]);

    const vendorsForProject = (projectId: string | number): TeamInfo[] => {
        const projectToken = projectInfo(projectId)?.unique_token;

        return vendorsByProject.find((projectVendor) => projectVendor.unique_token === projectToken)?.vendorTeams || [];
    };

    return {
        vendorsByProject,
        vendorsForProject,
        refreshVendorsByProject,
    };
};

export default useVendors;
